import { render } from "./DepositSignatureSection.vue?vue&type=template&id=61cd9c9e&scoped=true"
import script from "./DepositSignatureSection.vue?vue&type=script&lang=js"
export * from "./DepositSignatureSection.vue?vue&type=script&lang=js"

import "./DepositSignatureSection.vue?vue&type=style&index=0&id=61cd9c9e&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61cd9c9e"]])

export default __exports__